import { render } from "./PrimarySection.vue?vue&type=template&id=6507986c&scoped=true&ts=true"
import script from "./PrimarySection.vue?vue&type=script&lang=ts"
export * from "./PrimarySection.vue?vue&type=script&lang=ts"

import "./PrimarySection.vue?vue&type=style&index=0&id=6507986c&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6507986c"]])

export default __exports__